module.exports = __webpack_public_path__ + "house-classic-chrome.85ed051c0eb22c7fbfea.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/house-classic-chrome.svg
// module id = ../../../../../src/assets/img/house-classic-chrome.svg
// module chunks = main